module.exports = __webpack_public_path__ + "media/images/top/budget_table/kojin_pc_over1000-dcc78c40023e051c360b484004eeeb01.png";